import { ReferenceInput, SelectInput, required } from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { StudyTypes } from "utils/constants";
import { studentRequests } from "api/studentApi";
import { administrationRequests } from "api/administrationApi";

const SaveForm = ({ isEdit }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="academicYearId"
          reference={studentRequests.getAcademicYearsSelect()}
        >
          <SelectInput
            label="Академична година"
            helperText={false}
            validate={required()}
            readOnly={isEdit}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="studyTypeId"
          reference={administrationRequests.getStudyTypesSelect()}
          label="Вид на обучение"
        >
          <SelectInput
            optionText="name"
            label="Вид на обучение"
            validate={required()}
            defaultValue={!isEdit ? StudyTypes.Full_time : ""}
            emptyText={false}
            fullWidth
            readOnly={isEdit}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="type"
          resource={studentRequests.getAcademicSessionTypesSelect()}
          reference={studentRequests.getAcademicSessionTypesSelect()}
          filter={{ SessionsOnly: true }}
        >
          <SelectInput
            label="Тип"
            helperText={false}
            validate={required()}
            readOnly={isEdit}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="structuralUnitId"
          filter={{ filterByUser: true }}
          reference={administrationRequests.getStructuralUnitsSelect()}
        >
          <SelectInput
            label="Структурна единица"
            helperText={false}
            validate={required()}
            readOnly={isEdit}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="instructionLanguageId"
          reference={administrationRequests.getInstructionLanguagesSelect()}
        >
          <SelectInput
            label="Език на обучение"
            helperText={false}
            validate={required()}
            readOnly={isEdit}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Стартира на"
          source="startsOn"
          required={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Приключва на"
          source="endsOn"
          endOfDay
          required={true}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <CustomDateInput
          label="Удължен край"
          source="extendedEndsOn"
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
